import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { api } from '../lib/api';

/** Sign out, forget every cached screen, and go to the login page. */
export function useLogout() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: () => api.logout(),
    onSettled: () => {
      qc.clear();
      void navigate({ to: '/login' });
    },
    meta: { silent: true },
  });
}
